export function toggleActive() {
   // Open lightbox on click
   document.querySelectorAll('[data-role="trigger"]').forEach(function(el) {
      el.addEventListener('click', function(event) {
         el.closest('.js-toggle').classList.toggle('active');
      });
   });
}
